<app-filter-container>
    <form [formGroup]="filterForm">
        <app-form-section>
            <app-form-row>
                <h1>{{ 'MENU.DEVICE' | translate }}</h1>
            </app-form-row>
            <app-form-row>
                <app-search-input formControlName="searchPhrase" />
            </app-form-row>
        </app-form-section>
    </form>
</app-filter-container>
<app-table [loading]="loading" [clickable]="true">
    <tr thead>
        <app-table-header
            [isActive]="sortKey === 'serialNumber'"
            [defaultAscending]="sortKey === 'serialNumber' && sortAscending"
            [sort]="true"
            [dynamicWidth]="100"
            [text]="'FEATURES.DEVICE.SERIAL_NUMBER' | translate"
            (sortChanged)="onSortChange('serialNumber', $event)"
        />
        <app-table-header
            [isActive]="sortKey === 'softwareVersion'"
            [defaultAscending]="sortKey === 'softwareVersion' && sortAscending"
            [sort]="true"
            [width]="20"
            [text]="'FEATURES.DEVICE.SOFTWARE_VERSION' | translate"
            (sortChanged)="onSortChange('softwareVersion', $event)"
        />
        <app-table-header
            *ngIf="isUnrestricted"
            [isActive]="sortKey === 'tenantName'"
            [defaultAscending]="sortKey === 'tenantName' && sortAscending"
            [sort]="true"
            [width]="20"
            [text]="'GENERAL.TENANT' | translate"
            (sortChanged)="onSortChange('tenantName', $event)"
        />
        <app-table-header
            [isActive]="sortKey === 'calibrationStatusId'"
            [defaultAscending]="sortKey === 'calibrationStatusId' && sortAscending"
            [sort]="true"
            [width]="20"
            [text]="'FEATURES.DEVICE.CALIBRATION_STATUS' | translate"
            (sortChanged)="onSortChange('calibrationStatusId', $event)"
        />
    </tr>
    <ng-container tbody>
        <tr *ngFor="let item of devices$ | async" (click)="openCreateDeviceModal(item)">
            <td>{{ item.serialNumber }}</td>
            <td>
                <span class="version-container">
                    {{ item.softwareVersion }}
                    <span
                        *ngIf="item.deviceStatusId !== 0"
                        [ngClass]="getStatusColorClass(item.deviceStatusId)"
                        [appTooltip]="getStatusTooltipKey(item.deviceStatusId) | translate"
                        [tooltipPosition]="'left'"
                        class="status-badge"
                    >
                        {{ getStatusLabel(item.deviceStatusId) }}
                    </span>
                </span>
            </td>
            <td *ngIf="isUnrestricted">{{ item.tenantName }}</td>
            <td [appTooltip]="getCalibrationTooltip(item)" [tooltipPosition]="'left'">
                {{
                    item.calibrationStatusId === null || item.calibrationStatusId === undefined
                        ? '-'
                        : ('FEATURES.DEVICE.CALIBRATION_STATUSES.' + item.calibrationStatusId | translate)
                }}
            </td>
        </tr>
    </ng-container>
</app-table>
